
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.036 12.306l5.707 5.47 1.414-1.356-5.707-5.47c2.055-2.627 1.836-6.37-.657-8.76-2.734-2.62-7.166-2.62-9.9 0-2.733 2.62-2.733 6.867 0 9.487 2.494 2.39 6.4 2.6 9.143.63zM11.4 10.3l-.046.044c-1.954 1.85-5.103 1.842-7.048-.022a4.652 4.652 0 010-6.776c1.953-1.871 5.119-1.871 7.072 0a4.651 4.651 0 01.022 6.754z","fill":"#4B4B4B"}})])
          )
        }
      }
    